import { forwardRef, HTMLAttributes } from "react";
import * as SC from "./guide-line.styles";

export const GuideLine = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, style, ...props }, ref) => {
  return <SC.Line ref={ref} className={className} style={style} {...props} />;
});

GuideLine.displayName = "ProgressBarFullWidth.GuideLine";
